<template>
  <div>
    <!-- Figma design: label inside bordered box + يوم/شهر/سنة -->
    <div v-if="csDesign" class="cs-date-field">
      <div class="input__group cs-date-field__box">
        <div class="cs-date-field__title">{{ label }}</div>
        <div class="cs-date-field__parts">
          <div class="cs-date-part cs-date-part--day">
            <span class="cs-date-part__lbl">يوم</span>
            <input
              v-model="localHijri.day"
              type="number"
              min="1"
              max="30"
              maxlength="2"
              placeholder=""
            />
          </div>
          <div class="cs-date-part cs-date-part--month">
            <span class="cs-date-part__lbl">شهر</span>
            <input
              v-model="localHijri.month"
              type="number"
              min="1"
              max="12"
              maxlength="2"
              placeholder=""
            />
          </div>
          <div class="cs-date-part cs-date-part--year">
            <span class="cs-date-part__lbl">سنه</span>
            <input
              v-model="localHijri.year"
              type="number"
              min="1300"
              max="2000"
              maxlength="4"
              placeholder=""
            />
          </div>
        </div>
      </div>
    </div>

    <v-row
      v-else-if="$route.name !== 'customer_service_agent_data'"
      class="mr-1 agent-data-page2"
      dense
    >
      <v-col cols="1" class="pa-0 px-1 d-flex align-center justify-center">
        <v-btn
          type="button"
          icon
          x-small
          dense
          :aria-label="miladiInputMode ? 'إدخال هجري' : 'إدخال ميلادي'"
          @click="toggleInputMode"
        >
          <v-icon dense>mdi-swap-horizontal</v-icon>
        </v-btn>
      </v-col>

      <template v-if="!miladiInputMode">
        <v-col cols="2" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            v-model="localHijri.day"
            outlined
            dense
            hide-details
            label="ي"
            type="number"
            min="1"
            max="30"
          />
        </v-col>
        <v-col cols="2" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            v-model="localHijri.month"
            outlined
            dense
            hide-details
            label="ش"
            type="number"
            min="1"
            max="12"
          />
        </v-col>
        <v-col cols="3" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            v-model="localHijri.year"
            outlined
            dense
            hide-details
            label="س"
            type="number"
            min="1300"
            max="2000"
          />
        </v-col>
        <v-col cols="4" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            :value="miladiDate"
            readonly
            outlined
            dense
            hide-details
            label="الميلادي المقابل"
          />
        </v-col>
      </template>

      <template v-else>
        <v-col cols="2" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            v-model="localMiladi.day"
            outlined
            dense
            hide-details
            label="يوم"
            type="number"
            min="1"
            max="31"
          />
        </v-col>
        <v-col cols="2" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            v-model="localMiladi.month"
            outlined
            dense
            hide-details
            label="شهر"
            type="number"
            min="1"
            max="12"
          />
        </v-col>
        <v-col cols="3" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            v-model="localMiladi.year"
            outlined
            dense
            hide-details
            label="سنة"
            type="number"
            min="1900"
            max="2100"
          />
        </v-col>
        <v-col cols="4" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            :value="hijriDateFromMiladi"
            readonly
            outlined
            dense
            hide-details
            label="الهجري المقابل"
          />
        </v-col>
      </template>
    </v-row>

    <template v-else>
      <v-row class="mr-1 agent-data-page2" dense align="center">
        <v-col cols="1" class="pa-0 px-1 d-flex align-center justify-center">
          <v-btn
            type="button"
            icon
            x-small
            dense
            :aria-label="miladiInputMode ? 'إدخال هجري' : 'إدخال ميلادي'"
            @click="toggleInputMode"
          >
            <v-icon dense>mdi-swap-horizontal</v-icon>
          </v-btn>
        </v-col>

        <template v-if="!miladiInputMode">
          <v-col cols="3" class="pa-0 px-1">
            <v-text-field
              class="rm-fieldset-mr"
              v-model="localHijri.day"
              outlined
              dense
              hide-details
              label="يوم"
              type="number"
              min="1"
              max="30"
            />
          </v-col>
          <v-col cols="3" class="pa-0 px-1">
            <v-text-field
              class="rm-fieldset-mr"
              v-model="localHijri.month"
              outlined
              dense
              hide-details
              label="شهر"
              type="number"
              min="1"
              max="12"
            />
          </v-col>
          <v-col cols="5" class="pa-0 px-1">
            <v-text-field
              class="rm-fieldset-mr"
              v-model="localHijri.year"
              outlined
              dense
              hide-details
              label="سنة"
              type="number"
              min="1300"
              max="2000"
            />
          </v-col>
        </template>

        <template v-else>
          <v-col cols="3" class="pa-0 px-1">
            <v-text-field
              class="rm-fieldset-mr"
              v-model="localMiladi.day"
              outlined
              dense
              hide-details
              label="يوم (م)"
              type="number"
              min="1"
              max="31"
            />
          </v-col>
          <v-col cols="3" class="pa-0 px-1">
            <v-text-field
              class="rm-fieldset-mr"
              v-model="localMiladi.month"
              outlined
              dense
              hide-details
              label="شهر (م)"
              type="number"
              min="1"
              max="12"
            />
          </v-col>
          <v-col cols="5" class="pa-0 px-1">
            <v-text-field
              class="rm-fieldset-mr"
              v-model="localMiladi.year"
              outlined
              dense
              hide-details
              label="سنة (م)"
              type="number"
              min="1900"
              max="2100"
            />
          </v-col>
        </template>
      </v-row>

      <v-row v-if="miladiInputMode" class="mr-1 agent-data-page2" dense>
        <v-col cols="12" class="pa-0 px-1">
          <v-text-field
            class="rm-fieldset-mr"
            :value="hijriDateFromMiladi"
            readonly
            outlined
            dense
            hide-details
            label="الهجري المقابل"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import moment from 'moment-hijri';

function emptyParts() {
  return { day: '', month: '', year: '' };
}

export default {
  name: 'NewDateFields',
  props: {
    value: {},
    label: {
      type: String,
      default: '',
    },
    csDesign: {
      type: Boolean,
      default: false,
    },
    defaultHijri: {
      type: String,
      default: '',
    },
    defaultMiladi: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localHijri: emptyParts(),
      localMiladi: emptyParts(),
      miladiInputMode: false,
      muteWatch: false,
    };
  },
  computed: {
    miladiDate() {
      const { day, month, year } = this.localHijri;
      if (day && month && year) {
        const hijriStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const m = moment(hijriStr, 'iYYYY-iMM-iDD');
        return m.isValid() ? m.format('YYYY-MM-DD') : 'تاريخ غير صالح';
      }
      return '';
    },
    hijriDateFromMiladi() {
      const { day, month, year } = this.localMiladi;
      if (day && month && year) {
        const miladiStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const m = moment(miladiStr, 'YYYY-MM-DD');
        return m.isValid() ? m.format('iYYYY-iMM-iDD') : 'تاريخ غير صالح';
      }
      return '';
    },
  },
  watch: {
    value(v) {
      this.muteWatch = true;
      this.applyValueProp(v);
      this.$nextTick(() => {
        this.muteWatch = false;
      });
    },
    localHijri: {
      handler() {
        if (this.muteWatch || this.miladiInputMode) return;
        const { day, month, year } = this.localHijri;
        if (day && month && year && Number(year) > 1300) {
          const hijriFormatted = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          const m = moment(hijriFormatted, 'iYYYY-iMM-iDD');
          if (m.isValid()) {
            this.$emit('input', hijriFormatted);
            this.$emit('update:hijri', hijriFormatted);
            this.$emit('update:miladi', m.format('YYYY-MM-DD'));
          }
        }
      },
      deep: true,
    },
    localMiladi: {
      handler() {
        if (this.muteWatch || !this.miladiInputMode) return;
        const { day, month, year } = this.localMiladi;
        if (day && month && year && Number(year) >= 1900) {
          const miladiStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          const m = moment(miladiStr, 'YYYY-MM-DD');
          if (m.isValid()) {
            const hijriFormatted = m.format('iYYYY-iMM-iDD');
            this.$emit('input', hijriFormatted);
            this.$emit('update:hijri', hijriFormatted);
            this.$emit('update:miladi', m.format('YYYY-MM-DD'));
          }
        }
      },
      deep: true,
    },
  },
  created() {
    this.applyValueProp(this.value);
    if (this.defaultHijri) {
      const m = moment(this.defaultHijri, 'iYYYY-iMM-iDD');
      if (m.isValid()) {
        this.miladiInputMode = false;
        this.localHijri = {
          year: m.iYear(),
          month: m.iMonth() + 1,
          day: m.iDate(),
        };
      }
    } else if (this.defaultMiladi) {
      const m = moment(this.defaultMiladi, 'YYYY-MM-DD');
      if (m.isValid()) {
        this.miladiInputMode = true;
        this.localMiladi = {
          year: m.year(),
          month: m.month() + 1,
          day: m.date(),
        };
        this.syncHijriFromMiladiFields();
      }
    }
  },
  methods: {
    applyValueProp(v) {
      if (v && typeof v === 'object' && 'day' in v && 'month' in v && 'year' in v) {
        this.localHijri = { ...v };
        return;
      }
      if (v && typeof v === 'string' && v.includes('-')) {
        const m = moment(v, 'iYYYY-iMM-iDD');
        if (m.isValid()) {
          this.localHijri = {
            year: m.iYear(),
            month: m.iMonth() + 1,
            day: m.iDate(),
          };
        }
      }
    },
    syncHijriFromMiladiFields() {
      const { day, month, year } = this.localMiladi;
      if (!day || !month || !year) return;
      const miladiStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const m = moment(miladiStr, 'YYYY-MM-DD');
      if (m.isValid()) {
        this.muteWatch = true;
        this.localHijri = {
          year: m.iYear(),
          month: m.iMonth() + 1,
          day: m.iDate(),
        };
        this.$nextTick(() => {
          this.muteWatch = false;
        });
      }
    },
    syncMiladiFromHijriFields() {
      const { day, month, year } = this.localHijri;
      if (!day || !month || !year) return;
      const hijriStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const m = moment(hijriStr, 'iYYYY-iMM-iDD');
      if (m.isValid()) {
        this.muteWatch = true;
        this.localMiladi = {
          year: m.year(),
          month: m.month() + 1,
          day: m.date(),
        };
        this.$nextTick(() => {
          this.muteWatch = false;
        });
      }
    },
    toggleInputMode() {
      this.muteWatch = true;
      if (this.miladiInputMode) {
        this.syncHijriFromMiladiFields();
        this.miladiInputMode = false;
      } else {
        this.syncMiladiFromHijriFields();
        this.miladiInputMode = true;
      }
      this.$nextTick(() => {
        this.muteWatch = false;
        if (this.miladiInputMode) {
          this.emitFromMiladiIfComplete();
        } else {
          this.emitFromHijriIfComplete();
        }
      });
    },
    emitFromHijriIfComplete() {
      const { day, month, year } = this.localHijri;
      if (!day || !month || !year || Number(year) <= 1300) return;
      const hijriFormatted = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const m = moment(hijriFormatted, 'iYYYY-iMM-iDD');
      if (m.isValid()) {
        this.$emit('input', hijriFormatted);
        this.$emit('update:hijri', hijriFormatted);
        this.$emit('update:miladi', m.format('YYYY-MM-DD'));
      }
    },
    emitFromMiladiIfComplete() {
      const { day, month, year } = this.localMiladi;
      if (!day || !month || !year || Number(year) < 1900) return;
      const miladiStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const m = moment(miladiStr, 'YYYY-MM-DD');
      if (m.isValid()) {
        const hijriFormatted = m.format('iYYYY-iMM-iDD');
        this.$emit('input', hijriFormatted);
        this.$emit('update:hijri', hijriFormatted);
        this.$emit('update:miladi', m.format('YYYY-MM-DD'));
      }
    },
  },
};
</script>

<style scoped>
::v-deep input[type='number']::-webkit-inner-spin-button,
::v-deep input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>
